// Veilige toegang tot localStorage voor de Dagstart. In een privévenster, met
// geblokkeerde sitegegevens of in een ingebedde preview gooit `localStorage` bij
// lezen óf schrijven; een bewaarde voorkeur mag de pagina dan niet laten crashen.

/** Bewaarde keuze, alleen als die in `toegestaan` staat; anders (of bij een fout) `standaard`. */
export function leesKeuze(sleutel, toegestaan, standaard) {
  try {
    const bewaard = window.localStorage.getItem(sleutel);
    return (toegestaan || []).includes(bewaard) ? bewaard : standaard;
  } catch {
    return standaard;
  }
}

/** Bewaar een keuze; lukt dat niet, dan geldt hij alleen voor deze sessie. */
export function bewaarKeuze(sleutel, waarde) {
  try {
    window.localStorage.setItem(sleutel, waarde);
    return true;
  } catch {
    return false;
  }
}
